var map = {
	"./commander.png": 1841,
	"./forme.png": 280,
	"./imprimante.png": 1842,
	"./menu.png": 1843,
	"./multipad.png": 1844,
	"./pause.png": 281,
	"./play.png": 526,
	"./power.png": 1845,
	"./service.png": 1846,
	"./table.png": 1847,
	"./timer.png": 1848,
	"./toque.png": 1849,
	"./valide.png": 279
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1840;